import { render, staticRenderFns } from "./TemplateTable.vue?vue&type=template&id=39afc495&scoped=true"
import script from "./TemplateTable.vue?vue&type=script&lang=js"
export * from "./TemplateTable.vue?vue&type=script&lang=js"
import style0 from "./TemplateTable.vue?vue&type=style&index=0&id=39afc495&prod&scoped=true&lang=css"
import style1 from "./TemplateTable.vue?vue&type=style&index=1&id=39afc495&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39afc495",
  null
  
)

export default component.exports